// Admin Products Page translations
export const adminProductsTranslations = {
    en: {
        // Page header
        products: "Products",
        manageStoreProducts: "Manage your store products",

        // Action buttons
        addNewProduct: "Add New Product",
        viewSales: "View Sales",
        bulkActions: "Bulk Actions",
        delete: "Delete",
        setAsActive: "Set as Active",
        setAsInactive: "Set as Inactive",
        selected: "selected",

        // Search and filters
        searchProducts: "Search products...",
        allCategories: "All",
        allStatus: "All Status",
        active: "Active",
        draft: "Draft",
        outOfStock: "Out of Stock",
        inactive: "Inactive",

        // Quantity options
        unlimited: "Unlimited",
        unlimitedQuantity: "Unlimited Quantity",
        infiniteStock: "This product has infinite stock",

        // Table headers
        product: "Product",
        category: "Category",
        stock: "Stock",
        status: "Status",
        discount: "Discount",
        actions: "Actions",

        // Product row
        noImage: "No Image",
        variants: "variants",
        uncategorized: "Uncategorized",

        // Product actions
        edit: "Edit",
        addDiscount: "Add Discount",
        removeDiscount: "Remove Discount",
        removeAllDiscounts: "Remove all discounts",
        editProduct: "Edit Product",
        deleteProduct: "Delete Product",

        // Status badges
        processing: "Processing",
        shipped: "Shipped",
        delivered: "Delivered",
        cancelled: "Cancelled",

        // Empty states
        noProductsFound: "No products found. Try adjusting your filters or add a new product.",

        // Discount modal
        addDiscountTo: "Add Discount to",
        addDiscountToProducts: "Add Discount to {count} Products",
        addDiscountToVariants: "Add Discount to {count} Variant(s) of \"{productName}\"",
        discountType: "Discount Type",
        percentage: "Percentage",
        fixedAmount: "Fixed Amount",
        discountValue: "Discount Value",
        startDate: "Start Date",
        endDate: "End Date",
        applyDiscount: "Apply Discount",
        cancel: "Cancel",
        close: "Close",

        // Confirmation messages
        deleteConfirmation: "Are you sure you want to delete \"{productName}\"?",
        removeDiscountConfirmation: "Are you sure you want to remove all {count} discount(s) for this product?",

        // Loading states
        loadingProducts: "Loading products...",

        // Error messages
        failedToLoadProducts: "Failed to load products. Please try again.",
        failedToDeleteProduct: "Failed to delete product. Please try again.",
        failedToRemoveDiscount: "Failed to remove discount. Please try again.",

        // Discount info
        discountActive: "Active",
        discountExpired: "Expired",
        discountScheduled: "Scheduled",
        off: "off",
        save: "save",
        noDiscount: "No discount",

        // Product Editor
        editProduct: "Edit Product",
        newProduct: "New Product",
        saveProduct: "Save Product",
        saveChanges: "Save Changes",
        cancel: "Cancel",
        saving: "Saving...",

        // Tabs
        basicInfo: "Basic Info",
        images: "Images",
        variants: "Variants",
        seo: "SEO",
        shipping: "Shipping",

        // Basic Info Tab
        productName: "Product Name",
        productNamePlaceholder: "Enter product name",
        description: "Description",
        descriptionPlaceholder: "Describe your product",
        price: "Price",
        comparePrice: "Compare at Price",
        cost: "Cost per item",
        sku: "SKU",
        barcode: "Barcode",
        quantity: "Quantity",
        category: "Category",
        selectCategory: "Select a category",
        tags: "Tags",
        addTag: "Add Tag",
        enterTag: "Enter tag",

        // Images Tab
        productImages: "Product Images",
        uploadImages: "Upload Images",
        mainImage: "Main",
        removeImage: "Remove",
        noImagesUploaded: "No images uploaded",
        dragDropImages: "Drag and drop images here or click to upload",
        supportedFormats: "Supported formats: JPG, PNG, GIF",

        // AI Image Editor
        aiImageEditor: "AI Image Editor",
        aiImageEditorDescription: "Transform your product images with AI",
        upgradeToUseAI: "Upgrade to Premium to unlock AI Image Editing",
        upgradeMessage: "AI Image Editing is available for premium subscribers only. Contact us to enable this feature for your store.",
        contactSupport: "Contact Support",
        standardImageUpload: "Standard Image Upload",
        aiImageUpload: "AI Image Upload",

        // Variants Tab
        productOptions: "Product Options",
        addOption: "Add Option",
        optionName: "Option Name",
        optionValues: "Option Values",
        generateVariants: "Generate Variants",
        noOptionsMessage: "No options added yet. Add options like Size, Color, etc. to create product variants.",
        addValue: "Add Value",
        enterValue: "Enter value",
        removeOption: "Remove Option",
        variants: "Variants",
        noVariantsMessage: "No variants created yet. Add options above and click 'Generate Variants'.",
        variantPrice: "Price",
        variantQuantity: "Quantity",
        variantSku: "SKU",
        variantImages: "Images",
        manageImages: "Manage Images",
        variantImageManagement: "Variant Image Management",
        uploadVariantImages: "Upload Images for this Variant",
        noVariantImages: "No images for this variant",

        // SEO Tab
        seoSettings: "SEO Settings",
        seoTitle: "SEO Title",
        seoDescription: "SEO Description",
        seoKeywords: "SEO Keywords",
        seoTitlePlaceholder: "Enter SEO title",
        seoDescriptionPlaceholder: "Enter SEO description",
        seoKeywordsPlaceholder: "Enter keywords separated by commas",

        // Shipping Tab
        shippingInfo: "Shipping Information",
        weight: "Weight",
        dimensions: "Dimensions",
        width: "Width",
        height: "Height",
        length: "Length",
        weightUnit: "kg",
        dimensionUnit: "cm",

        // Validation Messages
        productNameRequired: "Product name is required",
        priceRequired: "Price is required",
        invalidPrice: "Please enter a valid price",
        categoryRequired: "Category is required",
        quantityMismatch: "Variant quantities ({variantTotal}) don't match total quantity ({total})",
        quantityExceeded: "Variant quantities ({variantTotal}) exceed total quantity ({total}). Please reduce by {difference} units.",
        quantityShortfall: "Variant quantities ({variantTotal}) are less than total quantity ({total}). Please distribute the remaining {difference} units or change the overall quantity.",

        // Status Options
        draft: "Draft",
        active: "Active",
        inactive: "Inactive",

        // Success Messages
        productSaved: "Product saved successfully",
        productCreated: "Product created successfully",
        productUpdated: "Product updated successfully",

        // Error Messages
        saveFailed: "Failed to save product",
        loadFailed: "Failed to load product",
        uploadFailed: "Failed to upload image"
    },
    ar: {
        // Page header
        products: "المنتجات",
        manageStoreProducts: "إدارة منتجات متجرك",

        // Action buttons
        addNewProduct: "إضافة منتج جديد",
        viewSales: "عرض المبيعات",
        bulkActions: "إجراءات مجمعة",
        delete: "حذف",
        setAsActive: "تعيين كنشط",
        setAsInactive: "تعيين كغير نشط",
        selected: "محدد",

        // Search and filters
        searchProducts: "البحث في المنتجات...",
        allCategories: "جميع الفئات",
        allStatus: "جميع الحالات",
        active: "نشط",
        draft: "مسودة",
        outOfStock: "نفد من المخزون",
        inactive: "غير نشط",

        // Quantity options
        unlimited: "غير محدود",
        unlimitedQuantity: "كمية غير محدودة",
        infiniteStock: "هذا المنتج لديه مخزون غير محدود",

        // Table headers
        product: "المنتج",
        category: "الفئة",
        stock: "المخزون",
        status: "الحالة",
        discount: "الخصم",
        actions: "الإجراءات",

        // Product row
        noImage: "لا توجد صورة",
        variants: "متغيرات",
        uncategorized: "غير مصنف",

        // Product actions
        edit: "تعديل",
        addDiscount: "إضافة خصم",
        removeDiscount: "إزالة خصم",
        removeAllDiscounts: "إزالة جميع الخصومات",
        editProduct: "تعديل المنتج",
        deleteProduct: "حذف المنتج",

        // Status badges
        processing: "قيد المعالجة",
        shipped: "تم الشحن",
        delivered: "تم التسليم",
        cancelled: "ملغى",

        // Empty states
        noProductsFound: "لم يتم العثور على منتجات. جرب تعديل المرشحات أو أضف منتجاً جديداً.",

        // Discount modal
        addDiscountTo: "إضافة خصم إلى",
        addDiscountToProducts: "إضافة خصم إلى {count} منتجات",
        addDiscountToVariants: "إضافة خصم إلى {count} متغير(ات) من \"{productName}\"",
        discountType: "نوع الخصم",
        percentage: "نسبة مئوية",
        fixedAmount: "مبلغ ثابت",
        discountValue: "قيمة الخصم",
        startDate: "تاريخ البداية",
        endDate: "تاريخ النهاية",
        applyDiscount: "تطبيق الخصم",
        cancel: "إلغاء",
        close: "إغلاق",

        // Confirmation messages
        deleteConfirmation: "هل أنت متأكد من أنك تريد حذف \"{productName}\"؟",
        removeDiscountConfirmation: "هل أنت متأكد من أنك تريد إزالة جميع الخصومات البالغ عددها {count} لهذا المنتج؟",

        // Loading states
        loadingProducts: "جاري تحميل المنتجات...",

        // Error messages
        failedToLoadProducts: "فشل في تحميل المنتجات. يرجى المحاولة مرة أخرى.",
        failedToDeleteProduct: "فشل في حذف المنتج. يرجى المحاولة مرة أخرى.",
        failedToRemoveDiscount: "فشل في إزالة الخصم. يرجى المحاولة مرة أخرى.",

        // Discount info
        discountActive: "نشط",
        discountExpired: "منتهي الصلاحية",
        discountScheduled: "مجدول",
        off: "خصم",
        save: "وفر",
        noDiscount: "لا يوجد خصم",

        // Product Editor
        editProduct: "تعديل المنتج",
        newProduct: "منتج جديد",
        saveProduct: "حفظ المنتج",
        saveChanges: "حفظ التغييرات",
        cancel: "إلغاء",
        saving: "جاري الحفظ...",

        // Tabs
        basicInfo: "المعلومات الأساسية",
        images: "الصور",
        variants: "المتغيرات",
        seo: "تحسين محركات البحث",
        shipping: "الشحن",

        // Basic Info Tab
        productName: "اسم المنتج",
        productNamePlaceholder: "أدخل اسم المنتج",
        description: "الوصف",
        descriptionPlaceholder: "صف منتجك",
        price: "السعر",
        comparePrice: "السعر المقارن",
        cost: "التكلفة لكل قطعة",
        sku: "رمز المنتج",
        barcode: "الباركود",
        quantity: "الكمية",
        category: "الفئة",
        selectCategory: "اختر فئة",
        tags: "العلامات",
        addTag: "إضافة علامة",
        enterTag: "أدخل علامة",

        // Images Tab
        productImages: "صور المنتج",
        uploadImages: "رفع الصور",
        mainImage: "الرئيسية",
        removeImage: "إزالة",
        noImagesUploaded: "لم يتم رفع أي صور",
        dragDropImages: "اسحب وأفلت الصور هنا أو اضغط للرفع",
        supportedFormats: "الصيغ المدعومة: JPG, PNG, GIF",

        // AI Image Editor
        aiImageEditor: "محرر الصور بالذكاء الاصطناعي",
        aiImageEditorDescription: "حوّل صور منتجاتك بالذكاء الاصطناعي",
        upgradeToUseAI: "ترقية إلى الإصدار المميز لاستخدام تحرير الصور بالذكاء الاصطناعي",
        upgradeMessage: "تحرير الصور بالذكاء الاصطناعي متاح للمشتركين المميزين فقط. تواصل معنا لتفعيل هذه الميزة لمتجرك.",
        contactSupport: "تواصل معنا",
        standardImageUpload: "رفع الصور العادي",
        aiImageUpload: "رفع بالذكاء الاصطناعي",

        // Variants Tab
        productOptions: "خيارات المنتج",
        addOption: "إضافة خيار",
        optionName: "اسم الخيار",
        optionValues: "قيم الخيار",
        generateVariants: "إنشاء المتغيرات",
        noOptionsMessage: "لم يتم إضافة خيارات بعد. أضف خيارات مثل الحجم واللون وما إلى ذلك لإنشاء متغيرات المنتج.",
        addValue: "إضافة قيمة",
        enterValue: "أدخل قيمة",
        removeOption: "إزالة الخيار",
        variants: "المتغيرات",
        noVariantsMessage: "لم يتم إنشاء متغيرات بعد. أضف خيارات أعلاه واضغط على 'إنشاء المتغيرات'.",
        variantPrice: "السعر",
        variantQuantity: "الكمية",
        variantSku: "رمز المنتج",
        variantImages: "الصور",
        manageImages: "إدارة الصور",
        variantImageManagement: "إدارة صور المتغير",
        uploadVariantImages: "رفع صور لهذا المتغير",
        noVariantImages: "لا توجد صور لهذا المتغير",

        // SEO Tab
        seoSettings: "إعدادات تحسين محركات البحث",
        seoTitle: "عنوان SEO",
        seoDescription: "وصف SEO",
        seoKeywords: "كلمات SEO المفتاحية",
        seoTitlePlaceholder: "أدخل عنوان SEO",
        seoDescriptionPlaceholder: "أدخل وصف SEO",
        seoKeywordsPlaceholder: "أدخل الكلمات المفتاحية مفصولة بفواصل",

        // Shipping Tab
        shippingInfo: "معلومات الشحن",
        weight: "الوزن",
        dimensions: "الأبعاد",
        width: "العرض",
        height: "الارتفاع",
        length: "الطول",
        weightUnit: "كيلو",
        dimensionUnit: "سم",

        // Validation Messages
        productNameRequired: "اسم المنتج مطلوب",
        priceRequired: "السعر مطلوب",
        invalidPrice: "يرجى إدخال سعر صحيح",
        categoryRequired: "الفئة مطلوبة",
        quantityMismatch: "كميات المتغيرات ({variantTotal}) لا تطابق الكمية الإجمالية ({total})",
        quantityExceeded: "كميات المتغيرات ({variantTotal}) تتجاوز الكمية الإجمالية ({total}). يرجى التقليل بـ {difference} وحدة.",
        quantityShortfall: "كميات المتغيرات ({variantTotal}) أقل من الكمية الإجمالية ({total}). يرجى توزيع الـ {difference} وحدة المتبقية أو تغيير الكمية الإجمالية.",

        // Status Options
        draft: "مسودة",
        active: "نشط",
        inactive: "غير نشط",

        // Success Messages
        productSaved: "تم حفظ المنتج بنجاح",
        productCreated: "تم إنشاء المنتج بنجاح",
        productUpdated: "تم تحديث المنتج بنجاح",

        // Error Messages
        saveFailed: "فشل في حفظ المنتج",
        loadFailed: "فشل في تحميل المنتج",
        uploadFailed: "فشل في رفع الصورة"
    }
};

// Translation helper function
export const useAdminProductsTranslation = (language = 'en') => {
    const t = (key, replacements = {}) => {
        let translation = adminProductsTranslations[language]?.[key] || adminProductsTranslations['en'][key] || key;

        // Handle string replacements like {count}, {productName}
        Object.keys(replacements).forEach(placeholder => {
            translation = translation.replace(new RegExp(`{${placeholder}}`, 'g'), replacements[placeholder]);
        });

        return translation;
    };

    return { t };
};